<template>
  <div class="dialog">
    <el-dialog
      :visible.sync="changVisible"
      :title="title"
      center
      width="746px"
      :before-close="$onClose"
      destroy-on-close
    >
      <div style="margin: 30px 100px 30px 20px; background-color: transparent">
        <!-- 工作状态 -->
        <div>
          <h4 class="must-mark title">工作状态</h4>
          <el-select
            v-model="status"
            placeholder="请选择"
            @change="changeSelectJob"
          >
            <el-option
              v-for="item in workStatusOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!-- 所在地 -->
        <div v-if="show_region">
          <h4 class="title">所在地</h4>
          <el-cascader
            class="input input_daterange"
            v-model="location"
            :options="regionOptions"
            :props="{ expandTrigger: 'hover' }"
            @change="handleRegionChange"
          ></el-cascader>
        </div>
        <!-- 单位名称 -->
        <div v-if="show_organization">
          <h4 class="must-mark title">
            单位名称
          </h4>
          <el-input v-model="organization" placeholder="请输入"></el-input>
        </div>
        <!-- 单位性质 -->
        <div v-if="show_unit_property">
          <h4 class="title">单位性质</h4>
          <el-select v-model="unit_property" placeholder="请选择">
            <el-option
              v-for="item in unitOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!-- 行业类型 -->
        <div v-if="show_job_type">
          <h4 class="title">行业类型</h4>
          <el-select v-model="job_type" placeholder="请选择">
            <el-option
              v-for="item in jobTypeOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!-- 工作职位 -->
        <div v-if="show_position">
          <h4 class="title">工作职位</h4>
          <el-input
            id="el_input_4"
            v-model="position"
            placeholder="请输入"
          ></el-input>
        </div>
        <!-- 薪酬范围 -->
        <div v-if="show_pay">
          <h4 class="title">薪酬范围</h4>
          <el-select v-model="pay" placeholder="请选择">
            <el-option
              v-for="item in payOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!-- 公司注册地 -->
        <div v-if="show_registered_address">
          <h4 class="title">公司注册地</h4>
          <el-input
            v-model="registered_address"
            placeholder="请输入"
          ></el-input>
        </div>
        <!-- 雇员人数 -->
        <div v-if="show_employees">
          <h4 class="title">雇员人数</h4>
          <el-select v-model="employees" placeholder="请选择">
            <el-option
              v-for="item in employeesOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!-- 年营业额 -->
        <div v-if="show_turnover">
          <h4 class="title">年营业额</h4>
          <el-select v-model="turnover" placeholder="请选择">
            <el-option
              v-for="item in turnoverOptions"
              :key="item"
              :value="item"
            ></el-option>
          </el-select>
        </div>
        <!-- 从事何种自由职业 -->
        <div v-if="show_freelance">
          <h4 class="title">从事何种自由职业</h4>
          <el-input v-model="freelance" placeholder="请输入"></el-input>
        </div>
      </div>

      <div class="footDialog">
        <el-button
          style="width: 106px; float: right"
          size="small"
          type="primary"
          v-preventReClick
          @click="save()"
          >保存</el-button
        >
        <el-button
          style="width: 106px; float: right; margin-right: 15px"
          size="small"
          @click="close()"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as StrUtils from "@/utils/strUtils.js";
import preventReClick from "@/utils//preventReClick"; //防多次点击，重复提交
import * as Constant from "@/utils/constant.js";

var thisIndex;
var thisUserName;
var thisType;
var thisInfo = {};

export default {
  data() {
    return {
      changVisible: false,
      title: "",

      show_unit_property: false,
      show_job_type: false,
      show_position: false,
      show_pay: false,
      show_region: false,
      show_organization: false,
      show_registered_address: false,
      show_employees: false,
      show_turnover: false,
      show_freelance: false,

      status: "",
      unit_property: "",
      job_type: "",
      position: "",
      pay: "",
      location: "",
      organization_nation: "",
      organization_province: "",
      organization_city: "",
      organization: "",
      registered_address: "",
      employees: "",
      turnover: "",
      freelance: "",

      clickLastTime: 0, //默认上一次点击时间为0
      regionOptions: JSON.parse(localStorage.getItem("options_region")),
      workStatusOptions: Constant.work_status_options, //工作状态
      unitOptions: Constant.unit_options, //单位性质
      jobTypeOptions: Constant.job_type_options, //行业类型
      payOptions: Constant.pay_options, //薪酬范围
      employeesOptions: Constant.employees_options, //雇员人数
      turnoverOptions: Constant.turnover_options, //年营业额
      isOrganization: false //单位名称是否必填
    };
  },
  methods: {
    changeSelectJob(select) {
      this.setHide();
      this.cleanInput();
      this.showInput();
    },
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
      this.status = "";
      this.setHide();
    },
    // 地区选择
    handleRegionChange(value) {
      this.organization_nation = value[0];
      this.organization_province = value[1];
      this.organization_city = value[2];
    },
    save() {
      let clickNow = new Date().valueOf();
      if (clickNow - this.clickLastTime < 2000) return;
      this.clickLastTime = clickNow;

      if (thisInfo == undefined) {
        thisInfo = {};
        thisInfo.id = 0;
      }
      thisInfo.delete_time = 0;
      if (StrUtils.isEmpty(this.status) ) {
        this.$message.error("请选择工作状态");
        return;
      }
      switch (thisType) {
        case "ais_job_info":
          // if (StrUtils.isEmpty(this.status) || this.isEmpty()) {
          //   this.$message.error("请填写单位名称");
          //   return;
          // }
          if (StrUtils.isEmpty(this.organization) && this.isOrganization) {
            this.$message.error("请填写单位名称");
            return;
          }
          thisInfo.status = this.status;
          thisInfo.unit_property = this.unit_property;
          thisInfo.job_type = this.job_type;
          thisInfo.position = this.position;
          thisInfo.pay = this.pay;
          thisInfo.organization_nation = this.organization_nation;
          thisInfo.organization_province = this.organization_province;
          thisInfo.organization_city = this.organization_city;
          thisInfo.organization = this.organization;
          thisInfo.registered_address = this.registered_address;
          thisInfo.employees = this.employees;
          thisInfo.turnover = this.turnover;
          thisInfo.freelance = this.freelance;
          thisInfo.location = StrUtils.getJobLocation(thisInfo);
          break;
      }
      this.changVisible = false;
      this.$emit("toSave", thisIndex, thisType, thisInfo);
    },
    showInput() {
      this.isOrganization = false;
      switch (this.status) {
        case "待业":
        case "深造":
          break;
        case "就业":
          this.show_region = true;
          this.show_organization = true;
          this.show_unit_property = true;
          this.show_job_type = true;
          this.show_position = true;
          this.show_pay = true;
          this.isOrganization = true;
          break;
        case "自主创业":
          this.show_region = true;
          this.show_organization = true;
          this.show_unit_property = true;
          this.show_job_type = true;
          this.show_registered_address = true;
          this.show_employees = true;
          this.show_turnover = true;
          this.show_position = true;
          this.show_pay = true;
          this.isOrganization = true;
          break;
        case "自由职业":
          this.show_region = true;
          this.show_job_type = true;
          this.show_freelance = true;
          break;
      }
    },
    isEmpty() {
      switch (this.status) {
        case "待业":
        case "深造":
          if (StrUtils.isEmpty(this.status)) {
            return true;
          }
          break;
        case "就业":
          if (
            StrUtils.isEmpty(this.status) ||
            StrUtils.isEmpty(this.location) ||
            StrUtils.isEmpty(this.organization) ||
            StrUtils.isEmpty(this.unit_property) ||
            StrUtils.isEmpty(this.job_type) ||
            StrUtils.isEmpty(this.position) ||
            StrUtils.isEmpty(this.pay)
          ) {
            return true;
          }
          break;
        case "自主创业":
          if (
            StrUtils.isEmpty(this.status) ||
            StrUtils.isEmpty(this.location) ||
            StrUtils.isEmpty(this.organization) ||
            StrUtils.isEmpty(this.unit_property) ||
            StrUtils.isEmpty(this.job_type) ||
            StrUtils.isEmpty(this.registered_address) ||
            StrUtils.isEmpty(this.employees) ||
            StrUtils.isEmpty(this.turnover) ||
            StrUtils.isEmpty(this.position) ||
            StrUtils.isEmpty(this.pay)
          ) {
            return true;
          }
          break;
        case "自由职业":
          if (
            StrUtils.isEmpty(this.status) ||
            StrUtils.isEmpty(this.location) ||
            StrUtils.isEmpty(this.job_type) ||
            StrUtils.isEmpty(this.freelance)
          ) {
            return true;
          }
          break;
      }
      return false;
    },
    //页面初始化时加载的事件
    show(index, userName, type, info) {
      this.setHide();
      this.cleanInput();
      this.status = "";
      this.changVisible = true;
      thisIndex = index;
      thisUserName = userName;
      thisType = type;
      thisInfo = info;

      switch (thisType) {
        case "ais_job_info":
          this.showDiv1SelectJob = true;
          if (thisInfo === undefined) {
            this.title = "新增 " + thisUserName + " 工作信息";
          } else {
            this.title = "编辑 " + thisUserName + " 工作信息";
            this.editJobInfo(thisInfo);
          }
          break;
      }
    },
    // 清除输入框
    cleanInput() {
      // this.status = "";
      this.unit_property = "";
      this.job_type = "";
      this.position = "";
      this.pay = "";
      this.location = "";
      this.organization_nation = "";
      this.organization_province = "";
      this.organization_city = "";
      this.organization = "";
      this.registered_address = "";
      this.employees = "";
      this.turnover = "";
      this.freelance = "";
    },
    setHide() {
      this.show_unit_property = false;
      this.show_job_type = false;
      this.show_position = false;
      this.show_pay = false;
      this.show_region = false;
      this.show_organization = false;
      this.show_registered_address = false;
      this.show_employees = false;
      this.show_turnover = false;
      this.show_freelance = false;
    },
    // 编辑工作信息
    editJobInfo(info) {
      this.status = info.status;
      this.unit_property = info.unit_property;
      this.job_type = info.job_type;
      this.position = info.position;
      this.pay = info.pay;
      this.location = StrUtils.getJobLocationArray(info);
      this.organization_nation = info.organization_nation;
      this.organization_province = info.organization_province;
      this.organization_city = info.organization_city;
      this.organization = info.organization;
      this.registered_address = info.registered_address;
      this.employees = info.employees;
      this.turnover = info.turnover;
      this.freelance = info.freelance;
      this.showInput();
    }
  }
};
</script>

<style lang="less" scoped>
.body .title {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/addEditJobDialog.vue